import type {
  AssetsBatchEditPropertyKey,
  AssetsBatchEditSelectProperties,
} from "./assets-batch-edit.type";
import type { AssetLite } from "@/entities/asset";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useDisableAssetsBatchEditAssetType } from "@/modules/assets/assets-batch-edit-asset-type";
import { useDisableAssetsBatchEditLocation } from "@/modules/assets/assets-batch-edit-location";
import { useDisableBatchTransition } from "@/modules/batch-transition";

export const useAssetsBatchEditProperties = (assets: AssetLite[]) => {
  const { t } = useTranslation();

  const [currentProperty, setCurrentProperty] =
    useState<AssetsBatchEditPropertyKey | null>(null);

  const stateDisabled = useDisableBatchTransition("asset", assets);
  const assetTypeDisabled = useDisableAssetsBatchEditAssetType(assets);
  const locationDisabled = useDisableAssetsBatchEditLocation(assets);

  const properties: AssetsBatchEditSelectProperties = [
    {
      value: "state",
      label: t("asset:batchEdit.state.optionTitle"),
      ...stateDisabled,
    },
    {
      value: "asset_type",
      label: t("asset:batchEdit.assetType.optionTitle"),
      ...assetTypeDisabled,
    },
    {
      value: "condition_rating",
      label: t("asset:batchEdit.conditionRating.optionTitle"),
    },
    {
      value: "replacement_cost",
      label: t("asset:batchEdit.replacementCost.optionTitle"),
    },
    {
      value: "location",
      label: t("asset:batchEdit.location.optionTitle"),
      ...locationDisabled,
    },
  ];

  return {
    properties,
    currentProperty,
    setCurrentProperty,
  };
};
